"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearFlag = exports.setFlag = exports.checkServerFlag = void 0;
function checkServerFlag(client, opts) {
    return client.post('check_server_flag', {
        flag: opts.flag,
        app_version: opts.appVersion
    });
}
exports.checkServerFlag = checkServerFlag;
function setFlag(client, opts) {
    return client.post('set_flag', { flag: opts.flag });
}
exports.setFlag = setFlag;
function clearFlag(client, opts) {
    return client.post('clear_flag', { flag: opts.flag });
}
exports.clearFlag = clearFlag;
